// import { useEffect, useState } from "react";
// import axios from "axios";
// import { apiurl } from "../config/config";
// import Layout, { Container } from "../components/layout";
// import { Bar } from "react-chartjs-2";
// import { motion, AnimatePresence } from "framer-motion";
// import {
//   Chart as ChartJS,
//   BarElement,
//   CategoryScale,
//   LinearScale,
//   Tooltip,
//   Legend,
// } from "chart.js";
// import ReportModal from "../components/reportModal";

// ChartJS.register(BarElement, CategoryScale, LinearScale, Tooltip, Legend);

// const formatDate = (date) => new Date(date).toISOString().split("T")[0];

// const LeaderboardCard = ({
//   name,
//   employeeId,
//   total,
//   selected,
//   rejected,
//   offered,
//   index,
// }) => (
//   <motion.div
//     initial={{ opacity: 0, y: 10 }}
//     animate={{ opacity: 1, y: 0 }}
//     transition={{ delay: index * 0.05 }}
//     className="bg-gradient-to-tr from-sky-500 to-indigo-600 text-white shadow-lg p-5 rounded-2xl hover:scale-105 transform transition"
//   >
//     <h4 className="text-xl font-bold capitalize">{name}</h4>
//     <p className="text-sm">ID: {employeeId}</p>
//     <div className="mt-2 space-y-1 text-sm">
//       <p>
//         Total: <span className="font-semibold">{total}</span>
//       </p>
//       {/* <p>Selected: <span className="font-semibold text-green-200">{selected}</span></p> */}
//       <p>
//         Rejected: <span className="font-semibold text-red-200">{rejected}</span>
//       </p>
//       <p>
//         Offered: <span className="font-semibold text-green-200">{offered}</span>
//       </p>
//     </div>
//   </motion.div>
// );

// const RecruiterLeaderboard = () => {
//   const [allTime, setAllTime] = useState([]);
//   const [datewise, setDatewise] = useState([]);
//   const [customStart, setCustomStart] = useState(formatDate(new Date()));
//   const [customEnd, setCustomEnd] = useState(formatDate(new Date()));
//   const [loading, setLoading] = useState(true);
//   const [isOpen, setIsOpen] = useState(false);
//   const [emailData, setEmailData] = useState({
//     email: "",
//     cc: "",
//     subject: "Recruiter Leaderboard Report",
//     message: "",
//   });
//   const [isLoading, setIsLoading] = useState(false);

//   const fetchLeaderboard = async (startDate, endDate, setter, endpoint) => {
//     const params = {};
//     if (startDate) params.startDate = startDate;
//     if (endDate) params.endDate = endDate;
//     const res = await axios.get(
//       `${apiurl}/api/analytic/reports/recruiter-leaderboard${endpoint}`,
//       { params }
//     );
//     setter(res.data.data || []);
//   };

//   useEffect(() => {
//     const today = formatDate(new Date());
//     setLoading(true);
//     fetchLeaderboard(null, null, setAllTime, "").then(() => {
//       fetchLeaderboard(today, today, setDatewise, "/datewise").then(() => {
//         setLoading(false);
//       });
//     });
//   }, []);

//   const handleCustomFetch = () => {
//     if (customStart && customEnd) {
//       fetchLeaderboard(customStart, customEnd, setDatewise, "/datewise");
//     }
//   };

//   const getChartData = (data) => ({
//     labels: data.map((d) => d.name),
//     datasets: [
//       {
//         label: "Total",
//         data: data.map((d) => d.total),
//         backgroundColor: "rgba(99, 102, 241, 0.7)",
//         borderRadius: 4,
//       },
//       {
//         label: "Offered",
//         data: data.map((d) => d.offered),
//         backgroundColor: "rgba(16, 185, 129, 0.7)",
//         borderRadius: 4,
//       },
//       {
//         label: "Rejected",
//         data: data.map((d) => d.rejected),
//         backgroundColor: "rgba(239, 68, 68, 0.7)",
//         borderRadius: 4,
//       },
//     ],
//   });

//   const chartOptions = {
//     responsive: true,
//     plugins: {
//       legend: { position: "top" },
//     },
//     scales: {
//       y: {
//         beginAtZero: true,
//         ticks: { stepSize: 1 },
//       },
//     },
//   };

//   console.log("Datewise Data:", datewise);

//   return (
//     <Layout>
//       <Container overflow="overflow-scroll">
//         <div className="p-6 space-y-10">
//           <div className="flex justify-between items-center mb-6">
//             <h2 className="text-3xl font-bold text-indigo-700">
//               Recruiter Leaderboard
//             </h2>
//             <button
//               onClick={() => setIsOpen(true)}
//               className="bg-indigo-600 hover:bg-indigo-700 text-white px-4 py-2 rounded shadow"
//             >
//               📤 Generate Report
//             </button>
//           </div>

//           {loading ? (
//             <p className="text-gray-500">Loading...</p>
//           ) : (
//             <>
//               {/* Filters and All-time Section */}
//               <div className="flex flex-col lg:flex-row gap-10">
//                 {/* Date Filter */}
//                 <div className="flex-1">
//                   <div className="flex gap-4 mb-4 flex-wrap">
//                     <h3 className="text-2xl font-semibold text-blue-600 mb-4">
//                       📅 Filter Datewise
//                     </h3>
//                     <input
//                       type="date"
//                       value={customStart}
//                       onChange={(e) => setCustomStart(e.target.value)}
//                       className="border px-4 py-2 rounded"
//                     />
//                     <input
//                       type="date"
//                       value={customEnd}
//                       onChange={(e) => setCustomEnd(e.target.value)}
//                       className="border px-4 py-2 rounded"
//                     />
//                     <button
//                       onClick={handleCustomFetch}
//                       className="bg-blue-700 text-white px-4 py-2 rounded hover:bg-blue-800"
//                     >
//                       Apply Filter
//                     </button>
//                   </div>

//                   <div className="bg-white p-4 rounded shadow">
//                     <h4 className="font-semibold text-purple-600 mb-2">
//                       📊 Datewise Graph
//                     </h4>
//                     {datewise.length ? (
//                       <Bar
//                         data={getChartData(datewise)}
//                         options={chartOptions}
//                       />
//                     ) : (
//                       <p className="text-gray-500">
//                         No data for selected range.
//                       </p>
//                     )}
//                   </div>
//                   {/* Datewise Table Listing */}
//                   <div className="mt-10">
//                     <h3 className="text-2xl font-semibold text-indigo-600 mb-4">
//                       📋 Datewise Recruiter Listing
//                     </h3>
//                     {datewise.length > 0 ? (
//                       <div className="overflow-x-auto rounded-lg shadow border">
//                         <table className="min-w-full divide-y divide-gray-200 text-sm">
//                           <thead className="bg-indigo-600 text-white">
//                             <tr>
//                               <th className="px-4 py-2 text-left">Name</th>
//                               <th className="px-4 py-2 text-left">
//                                 Employee ID
//                               </th>
//                               <th className="px-4 py-2 text-left">Total</th>
//                               <th className="px-4 py-2 text-left">Selected</th>
//                               <th className="px-4 py-2 text-left">Rejected</th>
//                               <th className="px-4 py-2 text-left">Offered</th>
//                             </tr>
//                           </thead>
//                           <tbody className="bg-white divide-y divide-gray-100">
//                             {datewise.map((item, idx) => (
//                               <tr key={idx} className="hover:bg-gray-50">
//                                 <td className="px-4 py-2 capitalize">
//                                   {item.name}
//                                 </td>
//                                 <td className="px-4 py-2">{item.employeeId}</td>
//                                 <td className="px-4 py-2 font-semibold">
//                                   {item.total}
//                                 </td>
//                                 <td className="px-4 py-2 text-green-700">
//                                   {item.selected}
//                                 </td>
//                                 <td className="px-4 py-2 text-red-600">
//                                   {item.rejected}
//                                 </td>
//                                 <td className="px-4 py-2 text-green-600">
//                                   {item.offered}
//                                 </td>
//                               </tr>
//                             ))}
//                           </tbody>
//                         </table>
//                       </div>
//                     ) : (
//                       <p className="text-gray-500">
//                         No data found for selected date range.
//                       </p>
//                     )}
//                   </div>
//                 </div>

//                 {/* All-Time Leaderboard */}
//                 <div className="lg:w-[300px] flex-none">
//                   <h3 className="text-2xl font-semibold text-green-600 mb-4">
//                     🏆 All-Time Top
//                   </h3>
//                   <div className="grid grid-cols-1 gap-4">
//                     {allTime.length > 0 ? (
//                       allTime.map((item, i) => (
//                         <LeaderboardCard key={i} {...item} index={i} />
//                       ))
//                     ) : (
//                       <p className="text-gray-500">No all-time data found.</p>
//                     )}
//                   </div>
//                 </div>
//               </div>

//               {/* Datewise Recruiter Cards */}
//               {/* <div className="mt-10">
//                 <h3 className="text-2xl font-semibold text-pink-600 mb-4">🔥 Datewise Leaderboard</h3>
//                 <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
//                   {datewise.length > 0 ? (
//                     datewise.map((item, i) => (
//                       <LeaderboardCard key={i} {...item} index={i} />
//                     ))
//                   ) : (
//                     <p className="text-gray-500 col-span-full">No datewise data found.</p>
//                   )}
//                 </div>

//                 <div className="mt-10 bg-white p-4 rounded shadow">
//                   <h4 className="font-semibold text-purple-600 mb-2">📈 Visual Summary (Bottom)</h4>
//                   {datewise.length > 0 ? (
//                     <Bar data={getChartData(datewise)} options={chartOptions} />
//                   ) : (
//                     <p className="text-gray-500">No data for selected range.</p>
//                   )}
//                 </div>
//               </div> */}
//             </>
//           )}
//         </div>

//         <ReportModal
//           show={isOpen}
//           startDate={customStart}
//           endDate={customEnd}
//           onClose={() => setIsOpen(false)}
//           isLoading={isLoading}
//         />
//       </Container>
//     </Layout>
//   );
// };

// export default RecruiterLeaderboard;

import { useEffect, useState } from "react";
import axios from "axios";
import { toast } from "react-toastify";
import { apiurl } from "../config/config";
import Layout, { Container } from "../components/layout";
import { Bar } from "react-chartjs-2";
import { motion } from "framer-motion";
import {
  Chart as ChartJS,
  BarElement,
  CategoryScale,
  LinearScale,
  Tooltip,
  Legend,
} from "chart.js";
import ReportModal from "../components/reportModal";

ChartJS.register(BarElement, CategoryScale, LinearScale, Tooltip, Legend);

const formatDate = (date) => new Date(date).toISOString().split("T")[0];

const allStatuses = [
  "applied",
  "shortlisted",
  "screening",
  "interviewing",
  "training",
  "selected",
  "offered",
  "on-hold",
  "rejected",
  "hired",
  "joined",
  "absconded",
  "onboarding",
  "not-joined",
  "decertified",  
  "certified"
];

const RecruiterLeaderboard = () => {
  const [datewise, setDatewise] = useState([]);
  const [customStart, setCustomStart] = useState(formatDate(new Date()));
  const [customEnd, setCustomEnd] = useState(formatDate(new Date()));
  const [loading, setLoading] = useState(true);
  const [isOpen, setIsOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const fetchDatewiseLeaderboard = async (startDate, endDate) => {
    try {
      setLoading(true);
      const { data } = await axios.get(
        `${apiurl}/api/analytic/reports/recruiter-leaderboard/datewise`,
        {
          params: { startDate, endDate },
        }
      );
      setDatewise(data.data || []);
    } catch (err) {
      toast.error("Failed to fetch leaderboard data.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const today = formatDate(new Date());
    fetchDatewiseLeaderboard(today, today);
  }, []);

  const handleCustomFetch = () => {
    if (!customStart || !customEnd) {
      toast.warning("Please select a valid date range.");
      return;
    }
    fetchDatewiseLeaderboard(customStart, customEnd);
  };

  const getChartData = (data) => ({
    labels: data.map((d) => d.name),
    datasets: [
      {
        label: "Total",
        data: data.map((d) => d.total),
        backgroundColor: "rgba(99, 102, 241, 0.7)",
        borderRadius: 4,
      },
      {
        label: "Offered",
        data: data.map((d) => d.offered),
        backgroundColor: "rgba(16, 185, 129, 0.7)",
        borderRadius: 4,
      },
      {
        label: "Rejected",
        data: data.map((d) => d.rejected),
        backgroundColor: "rgba(239, 68, 68, 0.7)",
        borderRadius: 4,
      },
    ],
  });

  const chartOptions = {
    responsive: true,
    plugins: { legend: { position: "top" } },
    scales: {
      y: { beginAtZero: true, ticks: { stepSize: 1 } },
    },
  };

  const filteredStatuses = allStatuses.filter(
    (status) =>
      ![
        "shortlisted",
        "screening",
        "absconded",
        "interviewing",
      ].includes(status)
  );

  return (
    <Layout>
      <Container overflow="overflow-scroll">
        <div className="p-4 space-y-10">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <h2 className="text-2xl font-bold text-indigo-700">
              Recruiter Leaderboard
            </h2>
            <button
              onClick={() => setIsOpen(true)}
              className="bg-indigo-600 hover:bg-indigo-700 text-white px-4 py-2 rounded shadow"
            >
              📤 Generate Report
            </button>
          </div>

          {/* Date Filter */}
          <div className="flex flex-wrap items-center gap-4">
            <input
              type="date"
              value={customStart}
              onChange={(e) => setCustomStart(e.target.value)}
              className="border px-4 py-2 rounded"
            />
            <input
              type="date"
              value={customEnd}
              onChange={(e) => setCustomEnd(e.target.value)}
              className="border px-4 py-2 rounded"
            />
            <button
              onClick={handleCustomFetch}
              className="bg-blue-700 text-white px-4 py-2 rounded hover:bg-blue-800"
            >
              Apply Filter
            </button>
          </div>

          {/* Chart Section */}
          <div className="bg-white p-4 rounded shadow">
            <h4 className="font-semibold text-purple-600 mb-2">📊 Graph</h4>
            {loading ? (
              <p className="text-gray-500">Loading...</p>
            ) : datewise.length ? (
              <Bar data={getChartData(datewise)} options={chartOptions} />
            ) : (
              <p className="text-gray-500">No data available.</p>
            )}
          </div>

          {/* Table Section */}
          <div>
            <h3 className="text-2xl font-semibold text-indigo-600 mb-4">
              📋 Recruiter Details
            </h3>
            {datewise.length > 0 ? (
              <div className="overflow-auto rounded-lg shadow border">
                <table className="min-w-full divide-y divide-gray-200 text-sm">
                  <thead className="bg-indigo-600 text-white">
                    <tr>
                      <th className="px-4 py-2 text-left">Recruiter</th>
                      <th className="px-4 py-2 text-left">Total</th>
                      {filteredStatuses.map((status) => (
                        <th
                          key={status}
                          className="px-4 py-2 text-left capitalize"
                        >
                          {status.replace("-", " ")}
                        </th>
                      ))}
                    </tr>
                  </thead>
                  <tbody className="bg-white divide-y divide-gray-100">
                    {datewise.map((item, idx) => (
                      <tr key={idx} className="hover:bg-gray-50">
                        <td className="px-4 py-2 capitalize">
                        <div>
                        <p>{item.name}</p>
                          SUW{item.recruiterId}
                        </div>
                      </td>
                        <td className="px-4 py-2 font-semibold">
                          {item.total}
                        </td>
                        {filteredStatuses.map((status) => (
                          <td key={status} className="px-4 py-2 text-center">
                            {item[status] ?? 0}
                          </td>
                        ))}
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            ) : (
              <p className="text-gray-500">No data found.</p>
            )}
          </div>

          {/* Report Modal */}
          <ReportModal
            show={isOpen}
            startDate={customStart}
            endDate={customEnd}
            onClose={() => setIsOpen(false)}
            isLoading={isLoading}
          />
        </div>
      </Container>
    </Layout>
  );
};

export default RecruiterLeaderboard;
